import actions from './constants';
import { defaultEvent } from './subscribers/helper';

export const showNotifications = (
  category,
  code,
  event,
  name,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
) => ({
  type: actions.SHOW_NOTIFICATIONS,
  category,
  code,
  name,
  event,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showNotificationsError = (category, code, event, error) => ({
  type: actions.SHOW_NOTIFICATIONS_ERROR,
  category,
  code,
  event,
  error,
});

export const showNotification = (category, code, event, notificationCode) => ({
  type: actions.SHOW_NOTIFICATION,
  category,
  code,
  event,
  notificationCode,
});

export const closeNotifications = ({ category, code }) => ({
  type: actions.CLOSE_NOTIFICATIONS,
  category,
  code,
  event: defaultEvent(category),
});
